import { paletteNames } from './Palette.types';

const buttonColors = paletteNames;
const defaultButtonColor = paletteNames.white;

const buttonVariants = {
    contained: 'contained',
    outlined: 'outlined',
    text: 'text',
}
const defaultButtonVariant = buttonVariants.contained;

const buttonWidth = {
    baseWidth: '',
    wide: 'wide',
}

const defaultButtonWidth = buttonWidth.baseWidth;

const buttonHeight = {
    baseHeight: '',
    high: 'high',
}

const defaultButtonHeight = buttonHeight.baseHeight;

export {
    buttonColors,
    defaultButtonColor,
    buttonVariants,
    defaultButtonVariant,
    buttonWidth,
    defaultButtonWidth,
    buttonHeight,
    defaultButtonHeight
}
